import { SeoSettings } from '../types';

export const DEFAULT_SEO_SETTINGS: SeoSettings = {
  siteTitleTemplate: '%s | Simatech Automation',
  defaultTitle: 'Industrial Automation & Siemens Integration | Simatech',
  defaultDescription:
    'Official Siemens Authorized System House & ISO 9001:2015 certified partner. Turnkey industrial automation, custom control panel manufacturing, SIMATIC S7-1500 PLC engineering, and SINAMICS VFD systems in Mumbai & Thane, India.',
  defaultKeywords:
    'Siemens Authorized System House, Turnkey Industrial Automation, Siemens S7-1500 PLC, SINAMICS VFD Drives, Control Panel Manufacturer Mumbai, SCADA System Integrator, Process Automation Thane',
  canonicalBaseUrl: 'https://simatechautomation.com',
  defaultOgImage: 'https://simatechautomation.com/simatech_logo.png',
  defaultTwitterCard: 'summary_large_image',
  robotsDefault: 'index, follow',

  googleSiteVerification: '',
  bingSiteVerification: '',
  googleAnalyticsId: '',
  googleTagManagerId: '',

  organizationName: 'SIMATECH AUTOMATION',
  organizationLegalName: 'Simatech Automation',
  organizationType: 'Organization',
  foundingYear: '2006',
  telephone: '+91-9820234033',
  email: 'info@simatechautomation.com',
  streetAddress: 'Gala No 1, 2, 3, 4, 1st Floor, Parmar Industrial Estate, Navghar, Vasai East',
  addressLocality: 'Vasai East, Thane',
  addressRegion: 'Maharashtra',
  postalCode: '401208',
  addressCountry: 'IN',
  geoLatitude: '19.3872',
  geoLongitude: '72.8361',
  socialSameAs: [
    'https://www.facebook.com/simatechautomation/',
    'https://www.instagram.com/simatechautomation/',
  ],

  pages: {
    home: {
      title: 'Industrial Automation & Siemens Integration | Simatech',
      description:
        'Official Siemens Authorized System House & ISO 9001:2015 certified partner. Turnkey industrial automation, certified Siemens system integration, and machine automation retrofit solutions with SIMATIC PLCs and SINAMICS VFD systems in Mumbai & Thane, India.',
      keywords:
        'Industrial Automation, Siemens System Integration, Machine Automation Retrofit, Siemens Authorized System House, Turnkey Industrial Automation, Siemens S7-1500 PLC, SINAMICS VFD Drives, Wire and Cable Automation',
      canonicalUrl: 'https://simatechautomation.com/',
      ogTitle: 'Industrial Automation & Siemens Integration | Simatech',
      ogDescription:
        'Authorized Siemens System House: Turnkey industrial automation, certified Siemens system integration, and machine automation retrofit solutions.',
      ogImage: 'https://simatechautomation.com/simatech_logo.png',
      robots: 'index, follow',
      schemaType: 'WebPage',
    },
    about: {
      title: 'About Simatech Automation | 20+ Years Industrial Automation Excellence',
      description:
        'Founded in 2006, Simatech Automation is an ISO 9001:2015 certified engineering firm & Siemens Channel Partner delivering turnkey automation and custom control panels to 27+ industry leaders globally.',
      keywords:
        'About Simatech Automation, Siemens Channel Partner India, Industrial Automation History, ISO 9001 Control Panels, Automation Engineering Team',
      canonicalUrl: 'https://simatechautomation.com/about/',
      ogTitle: 'About Simatech Automation | 20+ Years of Industrial Excellence',
      ogDescription:
        'Official Siemens Channel Partner & ISO 9001:2015 certified manufacturer of turnkey automation systems since 2006.',
      ogImage: 'https://simatechautomation.com/simatech_logo.png',
      robots: 'index, follow',
      schemaType: 'AboutPage',
    },
    services: {
      title: 'Turnkey Industrial Automation & Panel Manufacturing Services | Simatech',
      description:
        'End-to-end automation engineering: PLC & SCADA software architecture, custom electrical control panel fabrication, multi-axis VFD synchronization, and 24/7 AMC breakdown support.',
      keywords:
        'Turnkey Automation Services, Custom Control Panel Fabrication, PLC Programming Siemens, SCADA Software Architecture, Multi Axis Servo Synchronization, Industrial AMC Support',
      canonicalUrl: 'https://simatechautomation.com/services/',
      ogTitle: 'Turnkey Automation & Control Panel Manufacturing Services | Simatech',
      ogDescription:
        'Custom control panel manufacturing, SIMATIC PLC software development, VFD synchronization, and round-the-clock plant commissioning.',
      ogImage: 'https://simatechautomation.com/simatech_logo.png',
      robots: 'index, follow',
      schemaType: 'Service',
    },
    industry: {
      title: 'Industry Verticals & Manufacturing Sectors | Simatech Automation',
      description:
        'Engineered turnkey automation for 9 heavy manufacturing industries: Wire & Cable, Rubber, Pharmaceutical (21 CFR Part 11), Chemical, Oil & Gas, Steel Mills, Furnaces, Water Treatment, and Material Handling.',
      keywords:
        'Wire and Cable Automation, Pharmaceutical Automation 21 CFR Part 11, Rubber Extrusion Automation, Steel Mill Automation, SCADA Process Control, Hazardous Area Panels',
      canonicalUrl: 'https://simatechautomation.com/industry/',
      ogTitle: 'Industrial Automation Across 9 Heavy Manufacturing Sectors | Simatech',
      ogDescription:
        'Turnkey factory automation tailored for Wire & Cable, Rubber, Pharma, Chemical, Steel, and Oil & Gas manufacturing lines.',
      ogImage: 'https://simatechautomation.com/simatech_logo.png',
      robots: 'index, follow',
      schemaType: 'CollectionPage',
    },
    product: {
      title: 'Siemens Automation Products & Hardware | Authorized Channel Partner',
      description:
        'Authorized Siemens Channel Partner for SINAMICS VFD & DC drives, SIMATIC S7-1500/1200 PLCs, ET-200 distributed I/O, Comfort HMI panels, and WinCC SCADA systems with genuine warranty.',
      keywords:
        'Siemens Automation Products, SIMATIC S7-1500 PLC, SINAMICS V20 G120 Drives, Siemens HMI Panels, WinCC SCADA Software, Siemens Channel Partner Hardware',
      canonicalUrl: 'https://simatechautomation.com/product/',
      ogTitle: 'Siemens Industrial Automation Hardware & Drives | Simatech',
      ogDescription:
        'Genuine Siemens SIMATIC PLCs, SINAMICS Variable Frequency Drives, HMIs, and SCADA systems with direct technical support.',
      ogImage: 'https://simatechautomation.com/simatech_logo.png',
      robots: 'index, follow',
      schemaType: 'OfferCatalog',
    },
    clients: {
      title: 'Our Valued Clients & Global Partnerships | Simatech Automation',
      description:
        'Trusted by over 27+ industry giants across 14+ countries including Universal Cables, Nexans, Bhushan Steel, Polycab, Finolex, and Cipla for turnkey industrial automation and Siemens solutions.',
      keywords:
        'Simatech Clients, Universal Cables, Nexans Automation, Polycab Vendor, Industrial Automation Case Studies, Global Plant Commissioning',
      canonicalUrl: 'https://simatechautomation.com/clients/',
      ogTitle: 'Global Clients & Enterprise Partnerships | Simatech Automation',
      ogDescription:
        'See how Simatech powers manufacturing operations for Fortune 500 cable, steel, and chemical conglomerates globally.',
      ogImage: 'https://simatechautomation.com/simatech_logo.png',
      robots: 'index, follow',
      schemaType: 'AboutPage',
    },
    contact: {
      title: 'Contact Simatech Automation | Engineering Consultation & Technical Quote',
      description:
        'Connect with Simatech Automation senior engineers in Vasai East, Thane, Maharashtra. Request technical quotes for custom control panels, Siemens hardware, or turnkey plant retrofits.',
      keywords:
        'Contact Simatech, Simatech Automation Address, Request Automation Quote, Industrial Panel Consultation Thane, Siemens System House Contact',
      canonicalUrl: 'https://simatechautomation.com/contact/',
      ogTitle: 'Contact Engineering Team | Simatech Automation',
      ogDescription:
        'Get immediate pricing, CAD panel drawings, and project consultations from authorized Siemens automation specialists.',
      ogImage: 'https://simatechautomation.com/simatech_logo.png',
      robots: 'index, follow',
      schemaType: 'ContactPage',
    },
    'siemens-solution-partner': {
      title: 'Siemens Solution Partner & Authorized System House | Simatech Automation',
      description:
        'Official Siemens Solution Partner and Authorized System House. Certified industrial automation, SIMATIC S7-1500 PLC programming, SINAMICS VFD drive engineering, and custom IP55 control panels.',
      keywords:
        'Siemens Solution Partner, Siemens Authorized System House, Siemens Channel Partner India, SIMATIC S7-1500 System Integrator, SINAMICS Drive Specialist, TIA Portal Engineering, Siemens Automation Thane Mumbai',
      canonicalUrl: 'https://simatechautomation.com/siemens-solution-partner/',
      ogTitle: 'Siemens Solution Partner & Authorized System House | Simatech',
      ogDescription:
        'Official Siemens Solution Partner delivering certified turnkey automation, motion control, and custom control panels globally.',
      ogImage: 'https://simatechautomation.com/siemens_system_house.png',
      robots: 'index, follow',
      schemaType: 'AboutPage',
    },
  },
};